<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Vínculo - Exame (ConectaSUS)"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="laboratorioDescricao"
                        label="Laboratório"
                    />
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="model.nome"
                        label="Exame (Cliente)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :repository="repositories.parametrizacaoExame"
                        :request-query-string-params="{tipo_id: enums.tipoExame.EXAME_LABORATORIAL}"
                        :search-fields="fields.conectasusExame"
                        :validations="validations.conectasusExame"
                        label="Exame (ConectaSUS)"
                        uppercase
                        v-model="model.conectasusExame"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="save"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import tipoExame from '@/enums/parametrizacao/tipoExame'

export default {
    computed: {
        validations() {
            return {
                conectasusExame: {required: true},
            }
        },
        fields() {
            return {
                conectasusExame: [
                    { key: 'parametrizacaoExame.codigo', searchable: true },
                    { key: 'parametrizacaoExame.nome', searchable: true },
                ],
            }
        },
        laboratorioDescricao() {
            return this.form.laboratorios.find(l => l.id === this.model.laboratorioId).descricao
        }
    },
    created() {
        this.repositories = {
            parametrizacaoExame: this.getConectaSusRepository('parametrizacao.exame'),
            exame: this.getConectaSusRepository('webService.laboratorio.cliente.exame'),
        }
    },
    data: () => ({
        exameId: null,
        form: null,
        model: null,
        enums: {tipoExame},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(exameId) {
            this.exameId = exameId
            this.form = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.exame.edit(this.exameId)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        conectasusExameId: this.model.conectasusExame.id,
                    }

                    this.repositories.exame.update(this.model.laboratorioId, this.exameId, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
}
</script>